import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const adminLogoutData = createAsyncThunk(
  "getadminLogoutData",
  async (token) => {
    try {
      var { data } = await axios.get(
        "https://api.cricway.live/ad/api/v1/ad/logout/assa/admin-logout",
        {
          headers: {
            authorization: `bearer ${token}`,
          },
        }
      );
      // var {data} = await axios.get("http://localhost:8081/ad/api/v1/ad/getadminLogout/assa",{headers : {'Authorization': 'Bearer my-token'}});
      return data;
    } catch (err) {
      return err;
    }
  }
);

const adminLogoutSlice = createSlice({
  name: "adminLogout",
  initialState: {
    data: [],
    pending: false,
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminLogoutData.pending, (state) => {
        state.pending = true;
      })
      .addCase(adminLogoutData.fulfilled, (state, action) => {
        state.pending = false;
        state.data = action.payload;
        state.error = false;
      })
      .addCase(adminLogoutData.rejected, (state, action) => {
        state.pending = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});

export default adminLogoutSlice.reducer;
